Promise.all([import('embla-carousel'), import('scripts/marmalade/extensions/embla-plugins'), import('scripts/marmalade/functions/trap-focus')]).then(_ref => {
  let [moduleEmbla, moduleEmblaPlugins, functionTrapFocus] = _ref;
  // Define the components
  const EmblaCarousel = moduleEmbla.default;
  const {
    trapFocus
  } = functionTrapFocus;
  // Grab the plugins
  const {
    addDotBtnsAndClickHandlers
    // addPrevNextBtnsClickHandlers,
  } = moduleEmblaPlugins;

  // Find the button
  const button = document.querySelector('.js-notifications__button');
  // Find the widget
  const widget = document.querySelector('.js-notifications__widget');
  // Find the slider
  const slider = document.querySelector('.js-notifications__slider');
  // Find the items
  const links = [...document.querySelectorAll('.js-notifications__link')];
  // Create a new div for the dots
  const dotsNode = document.createElement('div');
  // Find the close button
  const close = document.querySelector('.js-notifications__close');
  // Get the widgetID
  const widgetID = widget.id;

  // We will store ID of the notification, that is currently being displayed, in the local storage, so we can keep track of it and notify the user only once
  const storageKey = 'notificationId';
  // Get the stored notification ID
  const storedID = localStorage.getItem(storageKey);

  // A way to toggle the notification
  let isOpen = false;
  // An autoplat interval
  let autoplayInterval;

  // Set up the Embla Carousel
  const Embla = EmblaCarousel(slider, {
    loop: true
  });
  function openNotification() {
    // Set the items to be focusable
    // [widget, close, ...links].forEach((link) => {
    // });
    // Add an active class to the widget
    widget.classList.add('active');
    widget.ariaHidden = false;
    widget.tabIndex = 0;
    widget.focus();
    // Remove the alert class from the button
    button.classList.remove('alert');
    button.ariaExpanded = true;

    // Update the stored ID to the current widget ID
    localStorage.setItem(storageKey, widgetID);
    // Set the widget to open
    isOpen = true;

    // Enable autoplay
    enableAutoplay();
  }
  function closeNotification() {
    // Hide the widget
    widget.classList.remove('active');
    widget.ariaHidden = true;
    widget.tabIndex = -1;
    // Focus the button
    button.ariaExpanded = false;
    button.focus();

    // Disable autoplay
    disableAutoplay();

    // Set the items to be hidden
    // [widget, close].forEach((link) => {
    // });

    // Set the widget to closed
    isOpen = false;
  }
  function toggleNotification() {
    isOpen ? closeNotification() : openNotification();
  }
  function enableAutoplay() {
    autoplayInterval = setInterval(() => Embla.scrollNext(), 2500);
  }
  function disableAutoplay() {
    clearInterval(autoplayInterval);
  }
  trapFocus(links);

  // If the stored ID is not the same as the widget ID, add an alert class to the button
  if (storedID !== widgetID) button.classList.add('alert');

  // Set the classes for the dots, previous, and next buttons
  dotsNode.classList.add('embla-dots');

  // When the button is clicked, show the widget
  button.addEventListener('click', toggleNotification);

  // When the button is clicked, show the widget
  button.addEventListener('keydown', e => {
    // If the user hits the right arrow key, open the mega menu
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      openNotification();
    }
  });

  // When the close button is clicked, hide the widget
  close.addEventListener('click', closeNotification);

  // Add the dots to the widget
  widget.appendChild(dotsNode);

  // If the user presses the left arrow key, close the notification
  widget.addEventListener('keydown', e => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      closeNotification();
    }

    // If the widget is the target, and the user presses shift + tab, close the notification
    if (e.target === widget && e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      closeNotification();
    }
  });

  // Disable autoplay when the widget is clicked
  widget.addEventListener('click', () => disableAutoplay());

  // Add the dot buttons and click handlers
  addDotBtnsAndClickHandlers(Embla, dotsNode);
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});